import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';

@Component({
  selector: 'app-historical-action-items',
  templateUrl: './historical-action-items.component.html',
  styleUrls: ['./historical-action-items.component.css']
})
export class HistoricalActionItemsComponent implements OnInit {
  isArabic: any;
  modalRefDeactivate!: BsModalRef;
  historicalActionPlansList: any;
  actionPlanEvent = new EventEmitter();

  constructor(
    private actionPlanService: ActionPlanService,
    private commonService: CommonService,
    private modalService: BsModalService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    let userData = this.storageService.getSessionStorageData('userDetails');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    const rqstBody = {
      assessmentUnitGuid: userData?.assessmentUnitValue,
      isHistorical: true
    };

    this.actionPlanService.getHistoricalActionPlans(rqstBody).subscribe((res: any) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get historical plans list : ', decryptedData);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.historicalActionPlansList = resp.actionPlans;
      }
    }), (error: any) => {
      //console.log('server error check: ', error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      }
    }
  }

  showActionPlanDetails(event: any) {
    if (event.target.nodeName == "BUTTON") {
      const attrList = Array.from(event.target.attributes).map((x: any) => x.name).filter((y: any) =>
        (y == "viewactionplan"));
      if (attrList?.length > 0) {
        let extractedId = event?.target?.id?.split("_")?.pop();
        let actionPlans = extractedId && this.historicalActionPlansList?.filter((item: any) => item?.actionPlanId == extractedId);
        if (actionPlans && actionPlans.length > 0 && actionPlans[0]) {
          let plan = actionPlans[0];
          if (plan) { this.actionPlanEvent.emit(JSON.stringify(plan)); }
          else { this.actionPlanEvent.emit(null) }
        }
      }
    }

  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

}
